var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"simple-slider container"},[_c('blog-component-wrapper',{attrs:{"component":_vm.additionalComponent}},[_c('div',{staticClass:"col-12 col-lg-9 offset-lg-1"},[_c('BaseSlider',{attrs:{"items":_vm.items}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }